import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  public currentUrl = new BehaviorSubject<string>('');
  public previousUrl = new BehaviorSubject<string>('');
  public moduleName = new BehaviorSubject<string>('');
  public breadcrum = new BehaviorSubject<any>([]);
  private uri = `${environment.apiUrl}`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private toast: ToastService,
    private appConfigService: AppConfigService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  myMethodChangingQueryParams(queryParams) {

    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  getJsonSignature(signaturePad) {
    let tempArray = [];
    let newTempArray = [];
    let arrayOfSignature = [];
    let requestString = '';
    if (signaturePad.toData().length > 0) {
      tempArray = signaturePad.toData();
      newTempArray = signaturePad.toData();
      requestString = '';
      try {
        for (let i = 0; i < tempArray.length; i++) {
          requestString += '[';
          for (let j = 0; j < tempArray[i].length; j++) {
            if (j == tempArray[i].length - 1) {
              requestString += ('[' + tempArray[i][j].x.toString() + ',' + tempArray[i][j].y.toString() + ']');
            }
            else {
              requestString += ('[' + tempArray[i][j].x.toString() + ',' + tempArray[i][j].y.toString() + '],');
            }
          }
          if (i == tempArray.length - 1) {
            requestString += ']';
          } else {
            requestString += '],';
          }

        }
        // alert(requestString)
        // saveSig();
      } catch (Ex) {
        // toast.(Ex.toString());
        ////////////////////////////////////////////
        for (let i = 1; i < tempArray.length; i++) {
          requestString += '[';
          for (let j = 0; j < tempArray[i].length; j++) {
            if (j == tempArray[i].length - 1) {
              requestString += ('[' + tempArray[i][j].x.toString() + ',' + tempArray[i][j].y.toString() + ']');
            } else {
              requestString += ('[' + tempArray[i][j].x.toString() + ',' + tempArray[i][j].y.toString() + '],');
            }
          }
          requestString += arrayOfSignature.toString();
          if (i == tempArray.length - 1) {
            requestString += ']';
          }
          else {
            requestString += '],';
          }

        }
        // saveSig();
      }
    } else {
      // toast.error('Please sign');
      requestString = ''
      return null;
    }
    return requestString;
  }

  getShowSignature(obj) {
    let _data = []
    // if (this.signature.length != 0) {
    // this.approvedBy = this.signatureDetails.SERVICEAPPROVEDBY;
    // this.signature = this.signature.substr(9, this.signature.length).substr(0, this.signature.length - 10);
    try {
      for (let i = 0; i < obj.length; i++) {
        _data.push([]);
        for (let j = 0; j < obj[i].length; j++) {
          _data[i].push({
            x: (obj[i][j][0]),
            y: (obj[i][j][1]),
            color: 'black',
            time: 0
          });
        }
      }

      return _data;
    } catch (error) {
      this.toast.error('Error with signature. Clear and try again.');
    }
    // }

    // console.log(_data);
    // setTimeout(() => {
    //   this.signaturePad.fromData(_data);
    // }, 3000);

  }

  DownloadDocument(path, filename) {

    // const formato = data.data.ATTACHMENT.split(".")

    // console.clear();
    // console.log('El attachment es: ' + formato);

    // switch(formato[1]){
    //   case 'PNG':tipo = "png";
    //   break
    //   case 'JPG':tipo = "jpeg";
    //   break
    //   case 'JPEG':tipo = "jpeg";
    //   break
    //   case 'docx':tipo = "vnd.openxmlformats-officedocument.wordprocessingml.document";
    //   break
    //   case 'doc':tipo = "msword";
    //   break
    //   case 'xls':tipo = "vnd.ms-excel";
    //   break
    //   case 'XLSX':tipo = "vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    //   break
    //   case 'pdf':tipo = "pdf";
    //   break
    //   case 'ZIP':tipo = "zip";
    //   break
    // }

    // console.log('El tipo es: ' + tipo);

    // var lfilepath = data.data.FILEPATH;

    this.GetDocument(path).subscribe(result => {

      let tipo = ""

      var data = result.filestring.substring(0, 5);

      if (!result || !result.filestring) {
        this.toast.warning('File not found.');
        return;
      }

      switch (data.toUpperCase()) {
        case "IVBOR": tipo = "png";
          break
        case "/9J/4": tipo = "jpeg";
          break
        case "JVBER": tipo = "pdf";
          break
        case "UESDB":
          var data2 = result.filestring.substring(0, 19);
          switch (data.toUpperCase()) {
            case "UEsDBBQABgAIAAAAIQB": tipo = "xlsx";
              break
            default:
              var data3 = result.filestring.substring(0, 18);
              switch (data.toUpperCase()) {
                case "UEsDBBQABgAIAAAAIQ": tipo = "docx";
                  break
                default: tipo = "zip";
              }
          }
          break
        case "UMFYI": tipo = "rar";
          break
        case "U1PKC": tipo = "txt";
          break
      }

      // let pdfWindow = window.open("")
      // console.log(result)
      // pdfWindow.document.write(
      //    "<iframe width='100%' height='100%' src='data:application/"+tipo+";base64," +
      //     encodeURI(result.filestring) + "'></iframe>"
      // )

      // var theFilename = new guid lfilepath.replace(/^.*[\\\/]/, '');

      var bytArray = Uint8Array.from(atob(result.filestring), c => c.charCodeAt(0));
      var blob = new Blob([bytArray], { type: "application/" + tipo });

      var link = document.createElement("a");
      link.download = filename;

      link.href = window.URL.createObjectURL(blob);

      link.click();


    })
  }

  DownloadDocumentByEstimateId(estimateId: string) {

    this.GetDocumentByEstimateID(estimateId).subscribe(result => {

      let tipo = ""

      var data = result.filestring.substring(0, 5);

      if (!result || !result.filestring) {
        this.toast.warning('File not found.');
        return;
      }

      switch (data.toUpperCase()) {
        case "IVBOR": tipo = "png";
          break
        case "/9J/4": tipo = "jpeg";
          break
        case "JVBER": tipo = "pdf";
          break
        case "UESDB":
          var data2 = result.filestring.substring(0, 19);
          switch (data.toUpperCase()) {
            case "UEsDBBQABgAIAAAAIQB": tipo = "xlsx";
              break
            default:
              var data3 = result.filestring.substring(0, 18);
              switch (data.toUpperCase()) {
                case "UEsDBBQABgAIAAAAIQ": tipo = "docx";
                  break
                default: tipo = "zip";
              }
          }
          break
        case "UMFYI": tipo = "rar";
          break
        case "U1PKC": tipo = "txt";
          break
      }

      var bytArray = Uint8Array.from(atob(result.filestring), c => c.charCodeAt(0));
      var blob = new Blob([bytArray], { type: "application/" + tipo });

      var link = document.createElement("a");
      link.download = "9550_Project_Part_Reference.pdf";

      link.href = window.URL.createObjectURL(blob);

      link.click();


    })
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  GetDocument(filepath): Observable<any> {
    return this.http.post(this.uri + '/DownloadFile/Download', { filename: filepath });
  }

  GetDocumentByEstimateID(estimateID: string): Observable<any> {
    return this.http.post(this.uri + '/DownloadFile/DownloadPdf', { "id": estimateID });
  }

  SaveUserSettings(model) {
    return this.http.post(this.uri + '/User/SaveUserSettings', model);
  }



  GetEmployees() {
    // return this.http.post<any>(this.uri + '/Employee', {});
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_EmployeeListAll' });
  }

  GeneralService(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  getInitials(item) {
    let strs = item.split(' ');
    let initials = '';
    if (strs.length > 1) {
      initials = `${strs[0].substr(0, 1)}${strs[1].substr(0, 1)}`;
    } else {
      initials = `${strs[0].substr(0, 1)}`;
    }

    return initials;
  }

  GetColorTaskStatus(statusid) {

    let statusidd = parseInt(statusid)

    if (Number.isInteger(statusidd)) {
      switch (statusid) {
        case 1:
          return 'orange';
        case 2:
          return 'blue';
        case 3:
          return 'green';
        case 4:
          return 'purple';
        case 5:
          return 'red';
        case 6:
          return 'grey';
        case 7:
          return 'pink';
        case 8:
          return 'brown';
        case 9:
          return 'black';
        default:
          return 'black';
      }
    } else {
      switch (statusid) {
        case 'Pre Bid':
          return 'orange';
        case 'Bid':
          return 'blue';
        // return '#12a5dd';
        case 'Sold':
          return 'green';
        case 'Design':
          return 'purple';
        case 'Abandoned':
          return 'red';
        case 'Lost':
          return 'grey';
        case 'Negotiating':
          return 'pink';
        case 'Prospect':
          return 'brown';
        case 'Unknown':
          return 'black';
        default:
          return 'black'
      }
    }

  }


  GetColorTaskPriority(priorityid) {

    let priorityidd = parseInt(priorityid)

    if (Number.isInteger(priorityidd)) {
      switch (priorityid) {
        case 1:
          return 'orange';
        case 2:
          return 'blue';
        case 3:
          return 'green';
        case 4:
          return 'purple';
        case 5:
          return 'red';
        case 6:
          return 'grey';
        case 7:
          return 'pink';
        case 8:
          return 'brown';
        case 9:
          return 'black';
        default:
          return 'black';
      }
    } else {
      switch (priorityid) {
        case 'Pre Bid':
          return 'orange';
        case 'Bid':
          return 'blue';
        // return '#12a5dd';
        case 'Sold':
          return 'green';
        case 'Design':
          return 'purple';
        case 'Abandoned':
          return 'red';
        case 'Lost':
          return 'grey';
        case 'Negotiating':
          return 'pink';
        case 'Prospect':
          return 'brown';
        case 'Unknown':
          return 'black';
        default:
          return 'black'
      }
    }

  }

  GetColorBidStatus(statusid) {

    let statusidd = parseInt(statusid)

    if (Number.isInteger(statusidd)) {
      switch (statusid) {
        case 1:
          return 'orange';
        case 2:
          return 'blue';
        case 3:
          return 'green';
        case 4:
          return 'purple';
        case 5:
          return 'red';
        case 6:
          return 'grey';
        case 7:
          return 'pink';
        case 8:
          return 'brown';
        case 9:
          return 'black';
        default:
          return 'black';
      }
    } else {
      switch (statusid) {
        case 'Pre Bid':
          return 'orange';
        case 'Bid':
          return 'blue';
        // return '#12a5dd';
        case 'Sold':
          return 'green';
        case 'Design':
          return 'purple';
        case 'Abandoned':
          return 'red';
        case 'Lost':
          return 'grey';
        case 'Negotiating':
          return 'pink';
        case 'Prospect':
          return 'brown';
        case 'Unknown':
          return 'black';
        default:
          return 'black'
      }
    }

  }

  quitChartesSpecials(string) {//solo letras y numeros
    var out = '';
    //Se añaden las letras validas
    var filtro = 'abcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNÑOPQRSTUVWXYZ1234567890.;.*´()-_ ';//Caracteres validos

    for (var i = 0; i < string.length; i++)
      if (filtro.indexOf(string.charAt(i)) != -1)
        out += string.charAt(i);
    return out;
  }

  getcurrentDate() {
    let f = new Date();
    let month: string;
    let day: string;

    if ((f.getMonth() + 1) < 10) {
      month = '0' + (f.getMonth() + 1);
    } else {
      month = (f.getMonth() + 1) + '';
    }
    if ((f.getDate()) < 10) {
      day = '0' + (f.getDate());
    } else {
      day = (f.getDate()) + '';
    }
    return (f.getFullYear() + (month) + day) + ' ' + f.getHours() + ':' + f.getMinutes() + ':' + f.getSeconds();
  }

  GetProjectBidStatus() {
    return this.http.post<any>(this.uri + '/ProjectBidStatus/', {});
  }

  SendSubscriptionNotification(projectid: any) {
    return this.http.post<any>(this.uri + '/Notifications/NotificationGeneric/', projectid);
  }

  getTemplateFile(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_EmailTemplateNameById', id: 6 } );
  }

  getToken(lchange: number){
    return this.http.post<any>(this.uri + '/FlexIntegration/getToken', { change: lchange } );
  }

  GetProjectByField(model) {
    return this.http.post<any>(this.uri + '/Pipeline/GetPipelineByField/', model);
  }

  GetSalesPerson() {
    return this.http.post<any>(this.uri + '/SalesPerson', {});
  }
  /**
   *
   * @param entity
   * @param idEntidad
   * @param params
   */
  getPopulateGeneral(entity: string, idEntidad?: any, params?: Object) {
    if (idEntidad) {
      return this.http.post<any>(this.uri + '/' + entity, { id: idEntidad });
    } else {
      if (params) {
        return this.http.post<any>(this.uri + '/' + entity, params);
      } else {
        return this.http.post<any>(this.uri + '/' + entity, {});
      }
    }

  }
  postInsertUpdategeneral(entity: string, idEntidad?: any, params?: Object) {
    if (idEntidad) {
      return this.http.post<any>(this.uri + '/' + entity, { id: idEntidad });
    } else {
      if (params) {
        return this.http.post<any>(this.uri + '/' + entity, params);
      } else {
        return this.http.post<any>(this.uri + '/' + entity, {});
      }
    }

  }


  SaveSite(data) {
    return this.http.post(this.uri + '/Site/InsertSite', data);

  }
  goToHome() {
    this.router.navigateByUrl('/home');
  }

  // getcurrentDate() {
  //   let f = new Date();
  //   let month: string;
  //   let day: string;

  //   if ((f.getMonth() + 1) < 10) {
  //     month = '0' + (f.getMonth() + 1);
  //   } else {
  //     month = (f.getMonth() + 1) + '';
  //   }
  //   if ((f.getMonth()) < 10) {
  //     day = '0' + (f.getDate());
  //   } else {
  //     day = (f.getDate()) + '';
  //   }
  //   return (f.getFullYear() + "-" + (month) + "-" + day);
  // }

  getCurrency(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Currency_ListCE'});
  }

  getParamethers(service){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'GetProcedureXMLParameters', procedurename: 'SP_API_Flex_'+service  });
  }

}
